import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

export const listarComprasViandas = async (token, incluirCompletadas = false) => {
	try {
		const response = await apiClient.get('/viandas/listarCompras', {
			headers: { Authorization: `Bearer ${token}` },
			params: { incluir_completadas: incluirCompletadas },
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				throw new Error(errorData.error || 'Se produjo un error al obtener compras de viandas.');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
